import React from "react";
import Home from "./Home";

export default function App() {
  return <Home />;
}
